import { getNewbuildingName } from '../newObject';
import { IState } from '../../store';
import { isAbUseExperimentGroup } from '../../utils/isAbUseExperimentGroup';
import { getNewbuildingId } from '../getNewbuildingId';
import { ICallbackContent } from '../../components/popups/callback/types';

export function isNBEnrollGroup(state: IState) {
  const { abUseExperiments } = state;

  return isAbUseExperimentGroup(abUseExperiments, 'newbuilding_enroll_or_booking', 'B');
}

export function isNBBookingGroup(state: IState) {
  const { abUseExperiments } = state;

  return isAbUseExperimentGroup(abUseExperiments, 'newbuilding_enroll_or_booking', 'C');
}

const DEFAULT_CALLBACK_CONTENT = {
  buttonText: 'Перезвоните мне',
  modalTitle: 'Оставьте номер телефона, и мы\u000Aперезвоним вам в течение минуты',
  modalButtonText: 'Перезвоните мне',
  successTitle: 'Оставьте номер телефона, и мы\u000Aперезвоним вам в течение минуты',
};

export function getCallBackContent(state: IState): ICallbackContent {
  const NBEnrollGroup = isNBEnrollGroup(state);
  const NBBookingGroup = isNBBookingGroup(state);
  const nbDisplayName = getNewbuildingName(state);
  const nbId = getNewbuildingId(state);

  if (!nbId) {
    return DEFAULT_CALLBACK_CONTENT;
  }

  if (NBEnrollGroup) {
    return {
      buttonText: 'Записаться на просмотр',
      modalTitle: `Запись на просмотр\u000Aв ЖК \u00AB${nbDisplayName}\u00BB`,
      modalDescription: 'Застройщик свяжется с вами для подтверждения записи.',
      successTitle: `Запись на просмотр\u000Aв ЖК \u00AB${nbDisplayName}\u00BB`,
      modalButtonText: 'Записаться на просмотр',
    };
  } else if (NBBookingGroup) {
    return {
      buttonText: 'Забронировать квартиру',
      modalTitle: `Бронирование квартиры\u000Aв ЖК \u00AB${nbDisplayName}\u00BB`,
      modalDescription: 'Застройщик свяжется с вами, чтобы помочь вам забронировать квартиру в этом ЖК.',
      successTitle: `Бронирование квартиры\u000Aв ЖК \u00AB${nbDisplayName}\u00BB`,
      modalButtonText: 'Забронировать квартиру',
    };
  } else {
    return DEFAULT_CALLBACK_CONTENT;
  }
}

export function isCalltrackingBadgeHiddenGroup(state: IState) {
  const { abUseExperiments } = state;

  return isAbUseExperimentGroup(abUseExperiments, 'without_calltracking_badge', 'enabled');
}
